<div *ngIf="!isLoading" class="worksheet ml-4 mr-4 pdf-font-{{ company?.appsettings?.pdfFontSize }}">
  <table class="width-100p">
    <thead class="report-header">
      <div class="worksheet-header">
        <!-- Company Details -->

        <!-- PDF LOGO -->
        <div class="worksheet-company pdfLogo-enable" *ngIf="company?.pdfLogo">
          <div class="worksheet-logo pr-3 align-self-start">
            <img [ngClass]="pdfLogoType" class="company-logo" [src]="company?.pdfLogo" [alt]="company?.name" />
          </div>
        </div>

        <!-- Default logo -->
        <div class="worksheet-company d-flex" *ngIf="!company?.pdfLogo">
          <div class="worksheet-logo pr-3 align-self-start">
            <img class="company-logo" [src]="company?.logo" [alt]="company?.name" />
          </div>
          <div class="worksheet-details flex-column">
            <span class="font-bold dynamicFont">{{ company?.name }}</span>
            <span>{{ company?.phone | mask: '(000) 000-0000' }}</span>
            <span>{{ company?.email }}</span>
            <span>{{ company.formattedAdress }} </span>
            <span *ngIf="company.regNumber && company.regNumber.includes(':')"
              [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)"> </span>

            <span *ngIf="company.regNumber && !company.regNumber.includes(':')"> {{ 'business/GST' | translate }}#: {{
              company?.regNumber }} </span>
          </div>
        </div>

        <!-- Estimate Details -->
        <div class="worksheet-title text-right width-320">
          <p class="mb-1 order-status-title font-600">{{ 'technician.technician-worksheet' | translate }}</p>
          <p class="mb-1 created-date">
            <span class="capitalize" *ngIf="order?.orderStatus !== 'invoice' && order?.orderStatus !== 'estimate'">{{
              order?.orderStatus }} # {{ order?.code }}</span>
            <span class="capitalize" *ngIf="order?.orderStatus === 'invoice'">{{ 'technician.invoice' | translate }} #
              {{ order?.orderStatus === 'invoice' && order?.invCode ? order?.invCode : order?.code }}</span>
            <span class="capitalize" *ngIf="order?.orderStatus === 'estimate'">{{ 'technician.estimate' | translate }} #
              {{ order?.orderStatus === 'invoice' && order?.invCode ? order?.invCode : order?.code }}</span>
          </p>
          <p class="m-0 dynamicFont created-date" *ngIf="order?.orderStatus === 'invoice'">{{
            'technician.against-estimate' | translate }}#: {{ order?.code }}</p>
          <p class="m-0 dynamicFont created-date">{{ 'technician.created' | translate }}: {{ order?.createdAt | date:
            'MMM d, y' }}</p>
          <p class="m-0 dynamicFont invoiced-date" *ngIf="order?.orderStatus === 'invoice'">{{ 'technician.invoiced' |
            translate }}: {{ order?.invoiceDate | date: 'MMM d, y' }}</p>
          <p class="m-0 dynamicFont service-advisor"
            *ngIf="order.displayServiceWriter && order.serviceWriter && order.serviceWriter.name">
            {{ 'technician.service-advisor' | translate }}: {{ order.serviceWriter && order.serviceWriter.name }}
          </p>
        </div>
      </div>
    </thead>
    <tbody class="report-body" *ngIf="order.displayServiceWriter && order.serviceWriter && order.serviceWriter.name">
      <tr style="height: 15px"></tr>
    </tbody>
    <br />
    <tbody class="report-body">
      <tr>
        <div class="worksheet-customer mb-15">
          <div class="worksheet-left flex-column align-self-start dynamicFont">
            <span class="font-bold">{{ customer?.fullName }}</span>
            <span class="font-bold" *ngIf="customer?.companyName && !customer?.isFleetCustomer">
              {{ customer?.companyName }}
            </span>
            <span *ngIf="isCustomerContactDetails">{{ customer?.phone | mask: '(000) 000-0000' }}</span>
            <span *ngIf="isCustomerContactDetails">{{ customer?.email }}</span>
            <span *ngIf="isCustomerAddress" class="mb-2">{{ customer?.address }}</span>
          </div>

          <div class="worksheet-right flex-column dynamicFont">
            <span class="font-bold">{{ vehicle?.vehicleName ? vehicle?.vehicleName : vehicle?.name }}</span>
            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'technician.VIN' | translate }}:</div>
              <div class="car-info-content">&nbsp;<span [innerHTML]="vehicle?.vehicleId?.VIN | highlightVin"></span>
              </div>
            </div>
            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'technician.engine' | translate }}:</div>
              <div class="car-info-content">&nbsp;{{ vehicle?.vehicleId?.engine }}</div>
            </div>
            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'technician.mileage' | translate }}{{ isTrackMileageInAndOut ? ' in' : ''
                }}:</div>
              <div class="car-info-content">
                &nbsp;{{ milage?.reading || 0 }} <span *ngIf="milage?.mileageMeasuringUnit">{{
                  milage?.mileageMeasuringUnit }}</span>
              </div>
            </div>
            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'technician.license-plate' | translate }}:</div>
              <div class="car-info-content">&nbsp;{{ vehicle?.vehicleId?.licensePlateNo }}</div>
            </div>
          </div>
        </div>
      </tr>

      <!-- Recommendation for customer -->
      <tr *ngIf="order?.customerNotes">
        <div class="worksheet-notes service-card">
          <div class="s-card-header">{{ 'recommendation-for-customer' | translate }}</div>
          <div class="s-card-body text-with-newlines border-bottom-0">
            {{ order?.customerNotes }}
          </div>
        </div>
      </tr>

      <!-- Shop Notes -->
      <tr *ngIf="order?.shopNotes">
        <div class="worksheet-notes service-card">
          <div class="s-card-header">{{ 'shop-notes' | translate }}</div>
          <div class="s-card-body text-with-newlines border-bottom-0">
            {{ order?.shopNotes }}
          </div>
        </div>
      </tr>
    </tbody>

    <tbody *ngFor="let group of techServiceGroupArray" class="worksheet-data-list">
      <tr>
        <div class="worksheet-notes service-card mb-0 border-bottom-0">
          <div class="s-card-header border-bottom-0">
            <span class="flex-between-start flex-column">
              {{ group?.techName || 'Unassigned' | translate }}
            </span>
          </div>
        </div>
      </tr>

      <tr *ngFor="let service of group?.services; let i = index" class="service-card-wrapper"
        [ngClass]="{ 'border-bottom': i === group?.services?.length - 1 }">
        <div class="service-card"
          [hidden]="service?.serviceStatus === 'deferred' || service?.serviceStatus === 'declined'">
          <div class="s-card-header group-header">
            <div class="header-top">
              <span class="flex-between-start flex-column" [innerHTML]="helperService.getLocalizationValue(currentLang, service, 'title')">
              </span>
            </div>
            <p class="font-weight-normal mt-2 mb-1" *ngIf="service?.notes">{{ 'service-notes' | translate }}: {{
              service?.notes }}</p>
          </div>

          <div class="s-card-body worksheet-service border-bottom-0">
            <div class="s-card-row flex-start-center">
              <p class="m-0 type font-bold pr-2">{{ 'technician.item-type' | translate }}</p>
              <p class="m-0 name font-bold pr-2">{{ 'technician.item-name' | translate }}</p>
              <p class="m-0 description font-bold">{{ 'technician.item-description' | translate }}</p>
              <p class="m-0 price font-bold">{{ 'technician.item-number' | translate }} #</p>
              <p class="m-0 total font-bold text-center">{{ 'technician.quantity' | translate }}</p>
            </div>

            <div *ngFor="let item of service?.items; let itemIndex = index" class="s-card-row"
              [ngClass]="{ 'pb-0 pt-0': item?.subItems?.length }">
              <div class="flex-start-center" [ngClass]="{ 'has-sub-item': item?.subItems?.length }">
                <p class="m-0 type align-self-start pr-2 capitalize">
                  {{currentLang === 'fr'? itemTypeLabelFR[item?.type] : itemTypeLabel[item?.type] }}
                </p>

                <p class="m-0 name align-self-start pr-2" [innerHTML]="item?.type === 'tireStorage' && item?.tireStorageStatus === 'return' ? 'Tires Out' : item?.type === 'tireStorage' && item?.tireStorageStatus !== 'return' ? 'Tires In - ' + helperService.getLocalizationValue(currentLang, item,'title') : helperService.getLocalizationValue(currentLang, item, 'title')"></p>

                <p class="m-0 description align-self-start"
                  [innerHTML]="helperService.getLocalizationValue(currentLang, item, 'description',true) || '-'">
                </p>

                <p class="m-0 price align-self-start item-number-style">
                  {{ item?.code || '-' }}
                </p>

                <p class="m-0 total text-center align-self-start">
                  {{ (item.pricingType === 'flatFee' && item.tireStorageStatus !== 'return' && item.type === 'tireStorage' && isTireStorage2Enabled ? 1 : item?.count) || '-' }}
                </p>
              </div>

              <div *ngFor="let subItem of item?.subItems; let itemIndex = index" class="s-card-row flex-start-center">
                <p class="m-0 type align-self-start pr-2 capitalize flex-start-center pl-4">
                  <i class="far fa-level-up-alt transform-90deg"></i>
                  <span class="pl-2">{{ currentLang === 'fr'? itemTypeLabelFR[subItem?.type] :
                    itemTypeLabel[subItem?.type] }}</span>
                </p>

                <p class="m-0 name align-self-start pr-2" [innerHTML]="helperService.getLocalizationValue(currentLang, subItem, 'title')">
                </p>

                <p class="m-0 description align-self-start"
                  [innerHTML]="helperService.getLocalizationValue(currentLang, subItem, 'description',true) || '-'">
                </p>

                <p class="m-0 price align-self-start">
                  {{ subItem?.code || '-' }}
                </p>

                <p class="m-0 total text-center align-self-start">
                  {{ subItem?.count || '-' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </tr>

      <tr class="service-md-space"></tr>
    </tbody>
  </table>
</div>